import styled from 'styled-components';

const ClearFile = styled.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
`;

export default ClearFile;
